import Link from "next/link";

import {
  hasNavigationLink,
  isNavigationMenuGroupItem,
} from "@/components/header/navigationQuery.types";
import { Text } from "@/components/text/text.component";

import { appendQueryString } from "@/utils/url.util";

import type { GetNavigationQueryResult } from "@/sanity.types";

import { SiteHeaderMegaMenu } from "./siteHeaderMegaMenu.component";
import { SiteHeaderNavAnimatedUnderline } from "./siteHeaderNavAnimatedLink.component";

export const SiteHeaderMainMenu = ({ menu }: SiteHeaderMainMenuProps) => {
  const renderNav = () => {
    if (!menu?.items?.length) return null;

    return menu.items.map((item) => {
      if (isNavigationMenuGroupItem(item)) {
        return <SiteHeaderMegaMenu key={item._key} menu={item} />;
      }

      if (!hasNavigationLink(item) || !item.link.url) return null;

      return (
        <li key={item._key} data-testid="site-header-main-menu-list-item">
          <Link
            href={
              appendQueryString(item.link.url, item.link.queryString) ??
              item.link.url
            }
            target={item.link.openInNewTab ? "_blank" : undefined}
            rel={item.link.openInNewTab ? "noopener noreferrer" : undefined}
            aria-label={item.label}
            data-testid="site-header-main-menu-link"
            className="group text-promo-black relative inline-block py-4 font-bold tracking-wider whitespace-nowrap uppercase">
            <Text variant="preHeaderMd" component="span" className="block">
              {item.label}
            </Text>
            <SiteHeaderNavAnimatedUnderline />
          </Link>
        </li>
      );
    });
  };

  return (
    <nav
      data-testid="site-header-main-menu"
      aria-label="Main menu"
      className="relative hidden w-full lg:block">
      <ul
        data-testid="site-header-main-menu-list"
        className="flex w-full items-center justify-between">
        {renderNav()}
      </ul>
    </nav>
  );
};

export type SiteHeaderMainMenuProps = {
  menu?: GetNavigationQueryResult;
};
